module.exports = __webpack_public_path__ + "img/icons-arrow-up-dark.142ff22c.svg";